const currency_switches = document.querySelectorAll('.site-header__language');
if(currency_switches.length) {
    for (let index = 0; index < currency_switches.length; index++) {
        const currency_switcher = currency_switches[index];
        
        currency_switcher.addEventListener('click', function() {
            document.querySelector('.language-popup').style.display = 'flex';
        })
    }
}


const currency_switcher_close_button = document.querySelector('.language-popup-content .close-button ');
if(currency_switcher_close_button) {
    currency_switcher_close_button.addEventListener('click', function() {
        document.querySelector('.language-popup').style.display = 'none';
    })
}

const language_select = document.querySelector('.language-locale-selectors__selector');
const currency_select = document.querySelector('.currency-locale-selectors__selector');
const currency_options = document.querySelectorAll('.currency-locale-selectors__selector option');

if(language_select) {
  language_select.addEventListener('change', function() {
    this.closest('form').action = this.value + '/localization';
    set_currency_to_display(this.value);
  }, false);
}

const set_currency_to_display = function(language) {
  	if(language == 'https://sittingsuits.dk') {
      currency_select.value = 'DKK';
        
      for (let index = 0; index < currency_options.length; index++) {
        const currency_option = currency_options[index];       
        
        if(currency_option.value === 'DKK') {
           currency_option.style.display = "block"; 
        } else {
           currency_option.style.display = "none";
        }
      }
    } else if(language == 'https://sittingsuits.se') {
      currency_select.value = 'SEK';
        
      for (let index = 0; index < currency_options.length; index++) {
        const currency_option = currency_options[index];       
        
        if(currency_option.value === 'SEK') {
           currency_option.style.display = "block"; 
        } else {
           currency_option.style.display = "none";
        }
      }
    } else if(language == 'https://sittingsuits.de') {
      currency_select.value = 'EUR';
        
      for (let index = 0; index < currency_options.length; index++) {
        const currency_option = currency_options[index];       
        
        if(currency_option.value === 'EUR') {
           currency_option.style.display = "block"; 
        } else {
           currency_option.style.display = "none";
        }
      }
    } else {
      if(
        currency_select.value == 'DKK'
        ||
        currency_select.value == 'SEK'
      ) {
        currency_select.value = 'EUR';
      }
      
      for (let index = 0; index < currency_options.length; index++) {
        const currency_option = currency_options[index];       
        if(currency_option.value === 'DKK') {
           currency_option.style.display = "none"; 
        } else if(currency_option.value === 'SEK') {
           currency_option.style.display = "none"; 
        } else {
           currency_option.style.display = "block";
        }
      } 
    }
}
set_currency_to_display(language_select.value);
